<template>
  <div class="login-wrapper">
    <img :src="bg" class="img" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      bg: require("./H5-02.png")
    };
  }
};
</script>
<style lang="less" scoped>
.login-wrapper {
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  .img {
    display: block;
    width: 100%;
  }
}
</style>
